(function () {
  var ICON_UNMUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
  var ICON_MUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M23 9l-6 6"/><path d="M17 9l6 6"/></svg>';
  var ICON_FULLSCREEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg>';

  // Completion threshold: 90%, not the ended event alone -- short clips
  // often never fire `ended` if the viewer scrolls away in the final second.
  var COMPLETION_RATIO = 0.9;

  function deterDownload(video) {
    // Best-effort deterrents only — casual right-click-save / drag-save, not
    // a real DRM barrier (anyone using devtools/network tab can still fetch
    // the source file; that's inherent to how <video> has to work).
    video.setAttribute('controlsList', 'nodownload noremoteplayback');
    video.setAttribute('disablePictureInPicture', '');
    video.setAttribute('draggable', 'false');
    video.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    video.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function requestVideoFullscreen(video) {
    // iOS Safari (and WKWebView-based in-app browsers, e.g. Instagram/Facebook)
    // generally don't support the standard Fullscreen API on arbitrary
    // elements, but DO support the video-specific webkitEnterFullscreen API —
    // try that first on iOS, fall back to the standard API elsewhere.
    if (video.webkitEnterFullscreen && /iP(hone|od|ad)/.test(navigator.userAgent)) {
      video.webkitEnterFullscreen();
    } else if (video.requestFullscreen) {
      video.requestFullscreen().catch(function () {});
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen();
    } else if (video.webkitEnterFullscreen) {
      video.webkitEnterFullscreen();
    } else if (video.msRequestFullscreen) {
      video.msRequestFullscreen();
    }
  }

  function setupCustomControls(media, video, trackId) {
    video.removeAttribute('controls');
    deterDownload(video);
    var muteBtn = document.createElement('button');
    muteBtn.type = 'button';
    muteBtn.className = 'sh-vid-mute';
    function updateIcon() {
      muteBtn.innerHTML = video.muted ? ICON_MUTED : ICON_UNMUTED;
      muteBtn.setAttribute('aria-label', video.muted ? (window.SH_I18N && window.SH_I18N.video_unmute_label || 'Geluid aan') : (window.SH_I18N && window.SH_I18N.video_mute_label || 'Dempen'));
    }
    muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      updateIcon();
    });

    var fsBtn = document.createElement('button');
    fsBtn.type = 'button';
    fsBtn.className = 'sh-vid-fullscreen';
    fsBtn.innerHTML = ICON_FULLSCREEN;
    fsBtn.setAttribute('aria-label', (window.SH_I18N && window.SH_I18N.video_fullscreen_label) || 'Volledig scherm');
    fsBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      requestVideoFullscreen(video);
    });

    video.addEventListener('click', function () {
      if (video.paused) video.play(); else video.pause();
    });
    updateIcon();
    media.appendChild(muteBtn);
    media.appendChild(fsBtn);

    if (trackId && window.SHVideoEvents) {
      var completionSent = false;
      function sendCompletion() {
        if (completionSent) return;
        completionSent = true;
        window.SHVideoEvents.trackCompletion(trackId);
      }
      video.addEventListener('ended', sendCompletion);
      video.addEventListener('timeupdate', function onCompletionCheck() {
        if (!video.duration) return;
        if (video.currentTime >= video.duration * COMPLETION_RATIO) {
          sendCompletion();
          video.removeEventListener('timeupdate', onCompletionCheck);
        }
      });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sh-video-trigger]');
    if (!btn) return;
    var media = btn.closest('.sh-media') || btn.parentElement;
    var tpl = media.querySelector('template[data-sh-video-src]');
    if (!tpl) return;
    var trackId = media.getAttribute('data-track-id');
    var frag = tpl.content.cloneNode(true);
    btn.replaceWith(frag);

    var video = media.querySelector('video');
    if (video) {
      setupCustomControls(media, video, trackId);
      // Start playback synchronously, in the SAME tap that inserted the
      // video, so mobile browsers recognize it as a user-gesture-triggered
      // play() call. Without this, the video only had the HTML `autoplay`
      // attribute to rely on, which mobile browsers evaluate asynchronously
      // (once metadata loads) and therefore do NOT treat as gesture-
      // authorized for unmuted media — so it silently failed to start, and
      // a second tap was needed to hit this video's own click-to-play
      // listener below. Swallow the promise rejection for browsers that
      // still decline (e.g. no prior interaction with the domain at all).
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
      if (trackId) {
        // Watch-time accumulation runs for the video's whole playback, so
        // this listener no longer removes itself once sh_video is set (see
        // below) -- it has to keep firing on every timeupdate to keep
        // sh_video_watch current. shPlaySent guards the one-time trackPlay
        // + sh_video write so that part still only fires once, same as before.
        var shWatchLastTime = 0;
        var shPlaySent = false;
        video.addEventListener('timeupdate', function onTime() {
          var current = video.currentTime;
          var delta = current - shWatchLastTime;
          shWatchLastTime = current;
          // Ignore seeks/loops: a backward jump gives a negative delta, a
          // forward jump (scrubbing ahead) gives a delta > 1s. Only count
          // delta as "watched" when it's consistent with normal playback.
          if (delta >= 0 && delta <= 1) {
            try {
              var watchMap = JSON.parse(sessionStorage.getItem('sh_video_watch') || '{}');
              watchMap[trackId] = (watchMap[trackId] || 0) + delta;
              sessionStorage.setItem('sh_video_watch', JSON.stringify(watchMap));
              // Persist this clip's duration alongside its watch time so
              // attribution can compare fraction-watched instead of raw
              // seconds -- otherwise a long clip only briefly played
              // out-scores a short clip watched in full. Read by
              // pickBestVideoId() in sh-video-events.js and sh-cart-drawer.liquid.
              if (isFinite(video.duration) && video.duration > 0) {
                var durationMap = JSON.parse(sessionStorage.getItem('sh_video_duration') || '{}');
                durationMap[trackId] = video.duration;
                sessionStorage.setItem('sh_video_duration', JSON.stringify(durationMap));
              }
            } catch (e) {}
          }
          if (!shPlaySent && current >= 2) {
            shPlaySent = true;
            if (window.SHVideoEvents) window.SHVideoEvents.trackPlay(trackId);
            // Phase 2 attribution: remember the most recently played video
            // for this session, as a fallback for when no sh_video_watch
            // data exists yet. attributeAddToCart() in sh-cart-drawer.liquid
            // prefers the highest-watch-time video from sh_video_watch and
            // only falls back to this last-touch value when that map is
            // empty or unavailable.
            try { sessionStorage.setItem('sh_video', trackId); } catch (e) {}
          }
        });
      }
    }
  });

  // Only one of these videos should ever play at a time. 'play' doesn't
  // bubble, so this has to listen on the capturing phase to catch it.
  document.addEventListener(
    'play',
    function (e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('sh-vid-el')) return;
      document.querySelectorAll('video.sh-vid-el').forEach(function (video) {
        if (video !== e.target && !video.paused) video.pause();
      });
    },
    true
  );
})();
